// Bump this string manually with each release. Must match the BE-side
// settings.FE_VERSION constant for the same release — the version-mismatch
// interceptor compares this to the X-FE-Version header BE returns.
export const FE_BUILD_VERSION = '2.29.14';
export default FE_BUILD_VERSION;
